module.exports = __webpack_public_path__ + "static/media/curve-top-modified-left.27878030.png";